// ==================== DOCTORS ====================
export const DOCTORS = {
  k: {
    id: 'k',
    name: 'د. كاي ريدفيلد جاميسون',
    short: 'د. جاميسون',
    emoji: '👩‍⚕️',
    title: 'نفسية إكلينيكية',
    specialty: 'علاج ديناميكي • CBT • دعم',
    tagline: 'للاستكشاف العميق وفهم الجذور',
    color: 'purple',
    accent: '#7c6bff',
    accent2: '#a898ff',
    bg: 'rgba(124, 107, 255, 0.08)',
    border: 'rgba(124, 107, 255, 0.35)',
    bio: 'أستاذة الطب النفسي بجامعة جونز هوبكنز، متخصصة في ثنائي القطب منذ 30 عاماً، وتعيش معه بنفسها'
  },
  g: {
    id: 'g',
    name: 'د. فريدريك كاي غودوين',
    short: 'د. غودوين',
    emoji: '👨‍⚕️',
    title: 'طبيب نفسي إكلينيكي',
    specialty: 'تقييم • أدوية • IPSRT',
    tagline: 'للدقة السريرية ومتابعة الدواء',
    color: 'teal',
    accent: '#16c4d4',
    accent2: '#4fd8e5',
    bg: 'rgba(22, 196, 212, 0.08)',
    border: 'rgba(22, 196, 212, 0.35)',
    bio: 'مدير NIMH السابق، مؤلف المرجع الأشمل في ثنائي القطب'
  }
};

// ==================== MOODS ====================
export const MOODS = [
  { emoji: '😊', label: 'بخير', code: 'great', color: '#22c97a', score: 5 },
  { emoji: '🙂', label: 'عادي', code: 'good', color: '#8bd8a6', score: 4 },
  { emoji: '😐', label: 'محايدة', code: 'neutral', color: '#b8c4e0', score: 3 },
  { emoji: '😔', label: 'منخفضة', code: 'low', color: '#7c6bff', score: 2 },
  { emoji: '😢', label: 'سيئة', code: 'bad', color: '#5020b8', score: 1 },
  { emoji: '⚡', label: 'طاقة زائدة', code: 'manic', color: '#f09018', score: 6 },
  { emoji: '😰', label: 'قلق', code: 'anxious', color: '#e5b850', score: 2 },
  { emoji: '😡', label: 'انفعال', code: 'irritable', color: '#ff6b6b', score: 2 }
];

export const QUICK_PROMPTS = [
  { icon: 'MessageCircle', text: 'أريد أتحدث عما أشعر به الآن' },
  { icon: 'Zap', text: 'أشعر بطاقة زائدة ولا أستطيع النوم' },
  { icon: 'CloudRain', text: 'أشعر بإرهاق وحزن شديد' },
  { icon: 'Search', text: 'أريد أفهم جذور ما أشعر به' },
  { icon: 'Pill', text: 'عندي أسئلة عن دوائي' },
  { icon: 'Wind', text: 'أحتاج تقنية تهدئني الآن' }
];

// ==================== RISK ====================
export const RISK_LABELS = { crisis: 'أزمة', alert: 'تنبيه', watch: 'مراقبة', none: 'طبيعي' };
export const RISK_COLORS = {
  crisis: { bg: 'rgba(255,61,61,.14)', text: '#ff6b6b', border: 'rgba(255,61,61,.3)' },
  alert: { bg: 'rgba(240,144,24,.12)', text: '#f09018', border: 'rgba(240,144,24,.3)' },
  watch: { bg: 'rgba(124,107,255,.12)', text: '#a898ff', border: 'rgba(124,107,255,.3)' },
  none: { bg: 'rgba(34,201,122,.08)', text: '#22c97a', border: 'rgba(34,201,122,.3)' }
};

// ==================== MOTIVATIONAL DAILY AFFIRMATIONS ====================
// مستوحاة من علم النفس الإيجابي وحكمة ثنائي القطب المعاش

export const AFFIRMATIONS = [
  { text: 'أنتِ لستِ عاصفتكِ، أنتِ السماء التي تحملها', author: 'حكمة بوذية' },
  { text: 'التعافي ليس أن تعودي لما كنتِ، بل أن تصبحي من كنتِ تحلمين أن تكوني', author: 'علم النفس الإيجابي' },
  { text: 'كل نفسٍ تأخذينه هو بداية جديدة', author: 'تأمل' },
  { text: 'لستِ وحدكِ في هذه الرحلة — الأمل معكِ', author: 'حكمة علاجية' },
  { text: 'الشجاعة ليست غياب الخوف، بل المضي رغمه', author: 'نيلسون مانديلا' },
  { text: 'خطوة اليوم لا تحتاج أن تكون كبيرة، فقط تكون', author: 'CBT' },
  { text: 'مشاعركِ زائرة وليست مقيمة — دعيها تمرّ', author: 'تأمل الوعي' },
  { text: 'جسدكِ يستحق الراحة، وعقلكِ يستحق السلام', author: 'DBT' },
  { text: 'التوازن ليس وجهة، بل رحلة يومية', author: 'فيريك غودوين' },
  { text: 'أنتِ أقوى ممّا تظنين، وأرقّ ممّا تحتاجين أن تكوني مع نفسكِ', author: 'كاي جاميسون' },
  { text: 'ليلة مظلمة واحدة لا تعني أن الفجر لن يأتي', author: 'حكمة عربية' },
  { text: 'اعتني بنفسكِ كما تعتنين بمن تحبين', author: 'الرحمة الذاتية' },
  { text: 'لا تقيسي تقدمكِ بحال غيركِ — رحلتكِ خاصة', author: 'علم النفس' },
  { text: 'في الصمت تنمو الحكمة، وفي التأمل يترمم القلب', author: 'تأمل' },
  { text: 'ثنائي القطب ليس من أنتِ، إنما ما تتعاملين معه', author: 'كاي جاميسون' }
];

// ==================== BREATHING EXERCISES ====================
export const BREATHING = [
  {
    id: '478',
    name: 'تنفس 4-7-8',
    subtitle: 'للنوم والقلق',
    description: 'يهدّئ الجهاز العصبي ويخفض معدل القلب. ابتكرها د. أندرو ويل.',
    pattern: [
      { phase: 'inhale', duration: 4, label: 'شهيق من الأنف' },
      { phase: 'hold', duration: 7, label: 'احبسي النفس' },
      { phase: 'exhale', duration: 8, label: 'زفير من الفم' }
    ],
    cycles: 4,
    color: '#7c6bff',
    when: 'قبل النوم • عند القلق'
  },
  {
    id: 'box',
    name: 'التنفس الصندوقي',
    subtitle: 'للتركيز والهدوء',
    description: 'تقنية يستخدمها نيفي سيلز والأطباء. توازن الجهاز العصبي.',
    pattern: [
      { phase: 'inhale', duration: 4, label: 'شهيق' },
      { phase: 'hold', duration: 4, label: 'احبسي' },
      { phase: 'exhale', duration: 4, label: 'زفير' },
      { phase: 'holdEmpty', duration: 4, label: 'انتظري' }
    ],
    cycles: 5,
    color: '#16c4d4',
    when: 'قبل موقف صعب • للتركيز'
  },
  {
    id: 'belly',
    name: 'تنفس البطن',
    subtitle: 'استرخاء عميق',
    description: 'يفعّل العصب المُبهم ويعزز الاسترخاء العميق.',
    pattern: [
      { phase: 'inhale', duration: 5, label: 'شهيق عميق للبطن' },
      { phase: 'exhale', duration: 6, label: 'زفير بطيء' }
    ],
    cycles: 6,
    color: '#22c97a',
    when: 'للاسترخاء اليومي'
  }
];

// ==================== GROUNDING ====================
export const GROUNDING_54321 = [
  { sense: 'أرى', count: 5, hint: 'اكتبي 5 أشياء ترينها حولك الآن', color: '#7c6bff', icon: 'Eye' },
  { sense: 'ألمس', count: 4, hint: 'اكتبي 4 أشياء يمكنكِ لمسها', color: '#16c4d4', icon: 'Hand' },
  { sense: 'أسمع', count: 3, hint: 'اكتبي 3 أصوات تسمعينها', color: '#22c97a', icon: 'Ear' },
  { sense: 'أشم', count: 2, hint: 'اكتبي 2 من الروائح حولك', color: '#f09018', icon: 'Flower2' },
  { sense: 'أتذوق', count: 1, hint: 'اكتبي شيئاً واحداً تتذوقينه', color: '#e5b850', icon: 'Coffee' }
];

// ==================== JOURNAL PROMPTS ====================
export const JOURNAL_PROMPTS = [
  'ما 3 أشياء أشعر بالامتنان لها اليوم؟',
  'ما الشعور السائد اليوم؟ وما الذي حفّزه؟',
  'إنجاز صغير حققته اليوم (حتى لو كان الاستيقاظ)',
  'رسالة رحيمة لنفسي في هذه اللحظة',
  'ما الذي أحتاجه الآن أكثر من أي شيء؟',
  'ماذا سأقول لصديقتي لو مرّت بما أمرّ به؟',
  'شخص واحد ممتنة لوجوده في حياتي، ولماذا؟'
];

// ==================== ACHIEVEMENTS ====================
export const ACHIEVEMENTS = [
  { id: 'first_session', icon: 'MessageCircle', label: 'الخطوة الأولى', desc: 'أول محادثة مع طبيب', color: '#7c6bff' },
  { id: 'streak_3', icon: 'Flame', label: 'ثلاثة أيام متتالية', desc: 'تسجيل مزاج لـ 3 أيام', color: '#f09018' },
  { id: 'streak_7', icon: 'Trophy', label: 'أسبوع من الاستمرارية', desc: '7 أيام من المتابعة', color: '#e5b850' },
  { id: 'breathing_5', icon: 'Wind', label: 'متنفسة واعية', desc: '5 جلسات تنفس', color: '#16c4d4' },
  { id: 'journal_10', icon: 'BookHeart', label: 'قلم مطمئن', desc: '10 كتابات في اليوميات', color: '#22c97a' },
  { id: 'meds_perfect', icon: 'Pill', label: 'ملتزمة بالعلاج', desc: 'أسبوع كامل بلا نسيان دواء', color: '#a898ff' }
];

// ==================== MED SCHEDULE TIMES ====================
export const MED_TIMES = [
  { code: 'morning', label: 'الصباح', hour: '08:00', icon: 'Sunrise', color: '#e5b850' },
  { code: 'noon', label: 'الظهيرة', hour: '13:00', icon: 'Sun', color: '#f09018' },
  { code: 'evening', label: 'المساء', hour: '19:00', icon: 'Sunset', color: '#c4982a' },
  { code: 'night', label: 'قبل النوم', hour: '22:00', icon: 'Moon', color: '#7c6bff' }
];

// ==================== CONFIG ====================
// Admin password and demo PIN validated via backend API (not exposed in frontend)
